var $b6518647ee722bc3$exports = {};
$b6518647ee722bc3$exports = {
  "help": "Hjelp",
  "info": "Informasjon"
};
export { $b6518647ee722bc3$exports as default };